export class DiveAN {
    constructor() {}
    commonStep = 'stepper.form.commun.divers.step';
    step = 'stepper.form.dive_an.step';
    step4 = 'stepper.form.dive_an.step4';
    step5 = 'stepper.form.dive_an.step5';
    step6 = 'stepper.form.dive_an.step5';
    step7 = 'stepper.form.dive_an.step7';
    step10 = 'stepper.form.dive_an.step10';
    step11 = 'stepper.form.dive_an.step11';
  }
